<div class="main-header top-header">
    <div class="container">
        <div class="header-container container">
            <div class="logo header-logo" *ngIf="!removeheaderData">
                <a routerLink="/main">
                    <img (load)="onImageLoad($event)" [src]="headerLogo" alt="" [ngStyle]="{'max-width': (logoSize - 10) + '%' }"
                        style="object-fit: contain;">
                </a>
            </div>
            <nav class="nav-bar header-nav">
                <ul class="menus" [ngStyle]="{'color': headerLinkColor}">
                    <!-- Commented to show HOME TAB  -->
                    <!-- <li *ngIf="!userName && isHomePage" routerLink="/main" routerLinkActive="active">{{mainPageName}} -->
                    <li *ngIf="isHomePage" routerLink="/main" routerLinkActive="active">{{mainPageName}}
                    </li>
                    <li routerLink="/vod" routerLinkActive="active" *ngIf="!isOnlyMediaEditor && isVodPage" [ngClass]="{'active':isVideoUrl}">
                        {{vodPageName}}
                    </li>
                    <li routerLink="/ebook-list" routerLinkActive="active" [ngClass]="{'active':isEbookUrl}"
                        *ngIf="!isOnlyMediaEditor && showHideEbook">{{ebookPage}}</li>
                    <li routerLink="/mobileApp" *ngIf="!isOnlyMediaEditor && isAppStore" routerLinkActive="active">{{appStoreName}}</li>
                    <li routerLink="/giving" *ngIf="!isOnlyMediaEditor && showHideGiving" routerLinkActive="active">{{givingPageName}}</li>
                    <li routerLink="/channel" *ngIf="!isOnlyMediaEditor && isChannelPage" routerLinkActive="active">{{channelName}}</li>
                    <!-- Manage Media dropdown — visible only for ROLE_MEDIA_EDITOR -->
                    <li class="manage-media-wrapper" *ngIf="userName && manageMediaOptions.length > 0" (click)="toggleManageMedia($event)">
                        <span class="manage-media-trigger" [class.open]="manageMediaOpen"
                            [class.active]="isManageMediaSectionActive()">
                            <span class="manage-media-trigger-label">Manage Media</span>
                            <i class="fa fa-angle-down manage-media-chevron" aria-hidden="true"></i>
                        </span>
                        <ul class="manage-media-dropdown" *ngIf="manageMediaOpen">
                            <li *ngFor="let option of manageMediaOptions" [class.active]="isManageMediaOptionActive(option)"
                                (click)="onManageMediaOptionClick(option, $event)">
                                {{ option.name }}
                            </li>
                        </ul>
                    </li>
                    <li routerLink="/frame" *ngIf="!isOnlyMediaEditor && isLivePage" routerLinkActive="active">{{livePageContent}}</li>
                    <li  *ngIf="!isOnlyMediaEditor && (isNetworkPage && networkPageType !== 'M3U')" routerLinkActive="active" routerLink="/network">{{networkName}}</li>
                    <li  *ngIf="!isOnlyMediaEditor && (isNetworkPage && networkPageType === 'M3U')" routerLinkActive="active" routerLink="/m3unetwork">{{networkName}}</li>
                    <li routerLink="/contact-us" routerLinkActive="active">{{contactName}}</li>
                    <li *ngIf="userName" routerLink="/Dashboard/menu" routerLinkActive="active">Dashboard</li>
                </ul>
            </nav>
            <div class="signin-wrapper header-signout">
                <app-header-upload-progress *ngIf="userName"></app-header-upload-progress>
                <div class="btn-group align-items-center" *ngIf="userName" dropdown>
                    <!-- <p class="signout" *ngIf="userName" (click)="signoutModal=true" style="cursor: pointer;">
                        Sign Out
                    </p> -->
                    <button class="btn signin main-btn" (click)="signoutModal=true" *ngIf="userName"
                    [style.background-color]="appBtnPrimaryColor">
                    Sign Out
                </button>
                </div>
                <!-- <div class="d-flex flex-column mt-3"> -->
                <button class="btn signin main-btn" routerLink="/signin" *ngIf="!userName"
                    [style.background-color]="appBtnPrimaryColor">
                    Sign In
                </button>
                <!-- <a [ngStyle]="{'color': headerLinkColor}" (click)="navigateForFreeAccount()" *ngIf="!userName"
                        class="cursor-pointer free-account">Create free
                        account</a> -->
                <!-- </div> -->
            </div>
            <div class="menu-icon" [ngClass]="{fixedIcon: removeheaderData}" (click)="openNav()">
                <span class="hamburger-icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                </span>
            </div>
            <nav class="nav-bar-mobile">
                <ul class="menus sidenav" id="mySidenav" [ngStyle]="{'color': headerLinkColor}">
                    <div class="arrowed" (click)="closeNav()">
                        <div class="arrow-6"></div>
                    </div>
                    <!-- <span class="close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span> -->
                    <li (click)="closeNav()"  *ngIf="!userName && isHomePage" routerLink="/main">{{mainPageName}}</li>
                    <li (click)="closeNav()" routerLink="/vod" *ngIf="!isOnlyMediaEditor && isVodPage">{{vodPageName}}</li>
                    <li (click)="closeNav()" routerLink="/ebook-list" routerLinkActive="active" *ngIf="!isOnlyMediaEditor && showHideEbook">
                        {{ebookPage}}</li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && isAppStore" routerLink="/mobileApp">{{appStoreName}}</li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && showHideGiving" routerLink="/giving">{{givingPageName}}</li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && isChannelPage" routerLink="/channel">{{channelName}}</li>
                    <!-- Manage Media — mobile -->
                    <li *ngIf="userName && (isMediaEditor || manageMediaOptions.length > 0)" class="mobile-manage-media-wrapper">
                        <span class="mobile-manage-media-trigger" (click)="toggleManageMedia($event)"
                            [class.open]="manageMediaOpen">
                            <span class="manage-media-trigger-label">Manage Media</span>
                            <i class="fa fa-angle-down manage-media-chevron" aria-hidden="true"></i>
                        </span>
                        <ul class="mobile-manage-media-submenu" *ngIf="manageMediaOpen">
                            <li *ngFor="let option of manageMediaOptions" [class.active]="isManageMediaOptionActive(option)"
                                (click)="closeNav(); onManageMediaOptionClick(option, $event)">
                                {{ option.name }}
                            </li>
                        </ul>
                    </li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && (isNetworkPage && networkPageType !== 'M3U')" routerLink="/network">{{networkName}}</li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && (isNetworkPage && networkPageType === 'M3U')" routerLink="/m3unetwork">{{networkName}}</li>
                    <li (click)="closeNav()" *ngIf="!isOnlyMediaEditor && isLivePage" routerLink="/frame">{{livePageContent}}</li>
                    <li (click)="closeNav()" routerLink="/contact-us">{{contactName}}</li>
                    <li (click)="closeNav()" *ngIf="userName" routerLink="/Dashboard/menu">Dashboard</li>
                    <li (click)="closeNav()" *ngIf="!userName" routerLink="/signin">Sign In</li>
                    <li (click)="closeNav()" *ngIf="userName" (click)="signoutModal=true">Sign Out</li>
                </ul>
            </nav>
        </div>
    </div>
</div>

<p-dialog *ngIf="signoutModal" [closable]="false" [showHeader]="false" header="" [(visible)]="signoutModal" [modal]="true"
    styleClass="signout-confirm-dialog" maskStyleClass="signout-confirm-mask"
    [style]="{ width: 'min(420px, 92vw)' }" [draggable]="false" [resizable]="false">
    <div class="showInfo1">
        <p>Are you sure you want to sign out ?</p>
    </div>
    <ng-template pTemplate="footer">
        <div class="signout-footer">
            <button type="button" class="btn signout-confirm-btn" (click)="logOut()">Yes</button>
            <button type="button" class="btn signout-confirm-btn" (click)="signoutModal = false">Cancel</button>
        </div>
    </ng-template>
</p-dialog>